import React, { FC, useState, useEffect, useCallback, Fragment, memo, useContext } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import { FormBuilder, IFORM } from 'featureLib/FormBuilder';
import { isFormValid } from 'featureLib/FormBuilder/form.validator';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';

import { OTP_NOTIFICATIONS, RESEND_OTP_TIME, DEFAULT_RESEND_COUNT, DEFAULT_OTP_LENGTH } from 'home/view/check-feasibility/unauth-view/constant';
import { sendOTP, verifyOTP } from 'home/view/manage-feasibility/services';
import { EnumRecipientType } from 'home/view/check-feasibility/comp-generator/common-interface';
import { DEFAULT_TOAST_MSG } from 'home/view/manage-feasibility/constants';
import { otpValidator } from 'common/utils/validator';
import { getFromSessionStorage, getVisibleFormFields, trackAnalytics, tranformCustomerDetail } from 'common/utils/app.utils';
import { createLead } from 'common/helper/api.helper';

import { CUSTOMER_DETAILS_FORM_CONFIG } from './formConfig';
import { AUTHORIZATION_HEADER, MODULE_ID } from 'home/common/constants/constants';
import { correlation } from 'common/utils/app.utils';
import { faOnDedicatedAuthCheckFeasibiliyPage, faOnDedicatedProceedClick } from 'dedicated/services/analytics.service';
import { setInSessionStorage } from 'common/utils/app.utils';
import { getProductType } from 'common/constants/app.constants';
import { createUpdateUnauthLead } from 'common/utils/app.utils';
import { trackGTM } from 'app-layout/utils';
import { AppContext } from 'App';

interface Props {
  isdedicatedJourney: boolean;
  showNotification: (show: boolean, message: string, type: typeof NOTIFICATION_TYPE[keyof typeof NOTIFICATION_TYPE], eventHandler?: Function, onCancel?: Function) => void;
  updateActiveIndex: (stepId: number) => void;
  customerDetailsFormState: IFORM;
  setCustomerDetailsFormState: React.Dispatch<React.SetStateAction<IFORM>>;
}

export const CustomerDetails: FC<Props> = (props) => {
  const { isdedicatedJourney, showNotification, updateActiveIndex, customerDetailsFormState, setCustomerDetailsFormState } = props;

  const { featureToggler } = useContext<any>(AppContext);
  const isOTPFeatureEnabled = featureToggler.OTP_FEATURE_ILL_ONLINE;

  const [loader, setLoader] = useState<boolean>(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [resendCount, setResendCount] = useState<number>(DEFAULT_RESEND_COUNT);

  const onSubmitCustomerDetailsForm = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setCustomerDetailsFormState(form?.values);
  }, []);

  const handleFormFieldChange = ({ field, value, oldValue, newValue, form }: { field: string; value: any; oldValue: any; newValue: any; form: IFORM }) => {
    // handle otp field change
    if (field === 'otp') {
      if (!value) {
        setCustomerDetailsFormState((customerDetailsFormState: any) => ({
          ...customerDetailsFormState,
          otp: {
            ...customerDetailsFormState.otp,
            className: !customerDetailsFormState.otp.className?.includes(' active')
              ? customerDetailsFormState.otp.className?.concat(' active')
              : customerDetailsFormState.otp.className,
            fieldMessage: OTP_NOTIFICATIONS.FIELD_MESSAGE,
            errors: [],
            value: ''
          }
        }));
      } else {
        const errors = otpValidator(newValue, DEFAULT_OTP_LENGTH);

        setCustomerDetailsFormState((customerDetailsFormState: any) => ({
          ...customerDetailsFormState,
          otp: {
            ...customerDetailsFormState.otp,
            value: newValue,
            errors,
            className: customerDetailsFormState.otp.className.replace(' active', ''),
            fieldMessage: ''
          }
        }));
      }
    }

    if (field === 'phoneNumber') {
      const isOTPFieldHidden = form?.otp?.hide;

      if (!isOTPFieldHidden && newValue !== oldValue) {
        setCustomerDetailsFormState((customerDetailsFormState: any) => ({
          ...customerDetailsFormState,
          otp: {
            ...customerDetailsFormState.otp,
            hide: true,
            className: customerDetailsFormState.otp.className.replace(' active', ''),
            fieldMessage: ''
          },
          phoneNumber: {
            ...customerDetailsFormState.phoneNumber,
            value: newValue
          }
        }));

        setResendCount(DEFAULT_RESEND_COUNT);
      }
    }
  };

  const onCustomerDetailsFormFieldChange = useCallback(
    (
      field: string,
      value: any,
      initialState: any,
      { setForm, form, disableAll, oldValue, newValue }: { setForm: Function; form: IFORM; disableAll: Function; oldValue: any; newValue: any }
    ) => {
      handleFormFieldChange({ form, field, value, oldValue, newValue });
    },
    []
  );
const onFieldBlurFn = (form:any,fieldValue:any) =>{
  //const selectdPlan = getFromSessionStorage(MODULE_ID,SELECTED_PLAN);
  trackAnalytics({
    eVar9: `b2b|dedicated internet|home page|${fieldValue && fieldValue.label ? fieldValue.label  :''}`,
    prop0: 'b2b|dedicated internet',
   // prop21: `${paranthesisText(selectdPlan?.name)} Plan`,
    prop35: form && form.companyName && form.companyName.value ? form.companyName.value : '',
    prop14: form && form.phoneNumber && form.phoneNumber.value ? form.phoneNumber.value : '',
    prop15: form && form.emailAddress && form.emailAddress.value ? form.emailAddress.value : '',
    prop17: form && form.fullName && form.fullName.value ? form.fullName.value : '',
  });
}
  const handleCreateLead = () => {
    const formValue = { ...customerDetailsFormState };
      const phoneNumber = formValue?.phoneNumber?.value;
      trackAnalytics({
        eVar0: 'b2b|dedicated internet|home page|feasibility|next',
        prop0: 'b2b| dedicated internet',
        prop14: phoneNumber,
        prop35: formValue?.companyName?.value,
        prop15: formValue?.emailAddress?.value,
        prop17: formValue?.fullName?.value,
        eVar5: 'uql_lead_created'
      });

    const successCb = () => updateActiveIndex(2);
    const payload = tranformCustomerDetail(customerDetailsFormState);

    const extraArgs = {
      setLoader,
      showNotification
    };

    createUpdateUnauthLead(payload, isdedicatedJourney, successCb, extraArgs);
  };

  const onVerifyOTP = async (notificationMessage = OTP_NOTIFICATIONS.VERIFIED) => {
    try {
      // setLoader(true);
      const formValue = { ...customerDetailsFormState };
      const phoneNumber = formValue?.phoneNumber?.value;
      const otpCode = formValue?.otp?.value;
      trackAnalytics({
        eVar0: 'b2b| dedicated internet| home page| feasibility| OTP| next',
        prop0: 'b2b| dedicated internet',
        prop14: phoneNumber,
        prop35: formValue?.companyName?.value,
        prop15: formValue?.emailAddress?.value,
        prop17: formValue?.fullName?.value
      });

      const reqPayload = {
        recipient: phoneNumber,
        recipientType: EnumRecipientType.PHONE,
        otpCode
      };

      const { res, err } = await verifyOTP(reqPayload);

      if (res?.data) {
        showNotification(false, '', '');

        // create lead
        handleCreateLead();
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
        const OTP_FIELD_ERROR = resendCount > 0 ? `Invalid OTP. You have ${resendCount} attempts left.` : `Limit exhausted. Please try after sometime.`;

        // setLoader(false);
        // showNotification(true, errorMsg, NOTIFICATION_TYPE.ERROR);
        trackAnalytics({
          eVar0: 'b2b| dedicated internet| home page| feasibility| OTP',
          prop0: 'b2b| dedicated internet',
          prop14: phoneNumber,
          prop35: formValue?.companyName?.value,
          prop15: formValue?.emailAddress?.value,
          prop17: formValue?.fullName?.value,
          prop19: otpCode
        });

        setCustomerDetailsFormState((customerDetailsFormState: any) => ({
          ...customerDetailsFormState,
          otp: {
            ...customerDetailsFormState.otp,
            errors: [OTP_FIELD_ERROR],
            fieldMessage: '',
            className: customerDetailsFormState.otp.className?.replace(' active', '')
          }
        }));
        setResendCount((resendCount) => resendCount - 1);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console?.error(e);
    }
  };

  const renderResendTimer = () => {
    setMinutes(RESEND_OTP_TIME.MIN);
    setSeconds(RESEND_OTP_TIME.SECONDS);
  };

  const onSendOTP = async (notificationMessage = OTP_NOTIFICATIONS.SENT) => {
    try {
      // setLoader(true);
      const formValue = { ...customerDetailsFormState };
      const phoneNumber = formValue?.phoneNumber?.value;

      const reqPayload = {
        recipient: phoneNumber,
        recipientType: EnumRecipientType.PHONE
      };
      const { res, err } = await sendOTP(reqPayload);
      if (res?.data) {
        // setLoader(false);
        // showNotification(true, res?.data ?? notificationMessage, NOTIFICATION_TYPE.SUCCESS);
        trackAnalytics({
          eVar0: 'b2b| dedicated internet| home page| feasibility| OTP',
          prop0: 'b2b| dedicated internet',
          prop14: phoneNumber,
          prop35: formValue?.companyName?.value,
          prop15: formValue?.emailAddress?.value,
          prop17: formValue?.fullName?.value
        });

        setCustomerDetailsFormState((customerDetailsFormState: any) => ({
          ...customerDetailsFormState,
          otp: {
            ...customerDetailsFormState.otp,
            hide: false,
            className: !customerDetailsFormState.otp.className?.includes(' active')
              ? customerDetailsFormState.otp.className?.concat(' active')
              : customerDetailsFormState.otp.className,
            fieldMessage: OTP_NOTIFICATIONS.FIELD_MESSAGE,
            value: '',
            errors: []
          }
        }));
        renderResendTimer();
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        // setLoader(false);
        // showNotification(true, errorMsg, NOTIFICATION_TYPE.ERROR);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console?.error(e);
    }
  };

  const onValidateMobileClick = () => {
    trackAnalytics({
      eVar9: 'b2b| dedicated internet| home page| feasibility| validate mobile number',
      prop0: 'b2b| dedicated internet',
      prop14: customerDetailsFormState?.phoneNumber?.value,
      prop35: customerDetailsFormState?.companyName?.value,
      prop15: customerDetailsFormState?.emailAddress?.value,
      prop17: customerDetailsFormState?.fullName?.value
    });
    trackGTM('validateNumber', 'forme|internet_leased_line|leadpage');

    onSendOTP();
  };

  const onReSendOTP = () => {
    trackAnalytics({
      eVar9: 'b2b| dedicated internet| home page| feasibility| OTP| resend OTP',
      prop0: 'b2b| dedicated internet',
      prop14: customerDetailsFormState?.phoneNumber?.value,
      prop35: customerDetailsFormState?.companyName?.value,
      prop15: customerDetailsFormState?.emailAddress?.value,
      prop17: customerDetailsFormState?.fullName?.value
    });

    onSendOTP(OTP_NOTIFICATIONS.RE_SENT);
  };

  const isProceedDisabled = () => {
    const filteredFields = getVisibleFormFields({ ...customerDetailsFormState });
    const isFormNotValid = !isFormValid(filteredFields);

    return isFormNotValid;
  };

  useEffect(() => {
    updateActiveIndex(1);
    trackAnalytics({
      eVar0: 'b2b| dedicated internet| home page| feasibility',
      prop0: 'b2b| dedicated internet'
    });
    trackGTM('SPAPV', 'forme|internet_leased_line|leadpage');
  }, []);

  // handle resend otp timer
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  const renderFooterSection = () => {
    if (!isOTPFeatureEnabled) {
      return (
        <Button onClick={() => handleCreateLead()} buttonClass="nextBtn" disabled={isProceedDisabled() || loader}>
          Next
          {loader && <span className="loading_icon"></span>}
        </Button>
      );
    }

    return (
      <Fragment>
        {customerDetailsFormState?.otp?.hide ? (
          <Button onClick={onValidateMobileClick} buttonClass="validateBtn" disabled={isProceedDisabled()}>
            Validate Mobile Number
            {/* {loader && <span className="loading_icon"></span>} */}
          </Button>
        ) : (
          <Fragment>
            <Button onClick={onVerifyOTP} buttonClass="nextBtn" disabled={isProceedDisabled() || loader}>
              Next
              {loader && <span className="loading_icon"></span>}
            </Button>
            {seconds > 0 || minutes > 0 ? (
              <p className="resend-timer">
                You can re-send OTP in {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds} min
              </p>
            ) : (
              <Button onClick={onReSendOTP} buttonClass="resendBtn" variant="transparentbtn">
                Resend OTP
                {/* {loader && <span className="loading_icon"></span>} */}
              </Button>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  };

  return (
    <div className="customer_form_section">
      <div className="row">
        <FormBuilder formConfig={customerDetailsFormState} onSubmit={onSubmitCustomerDetailsForm} onChange={onCustomerDetailsFormFieldChange} onFieldBlurFn={onFieldBlurFn}></FormBuilder>
      </div>
      <div className="btn_section">{renderFooterSection()}</div>
    </div>
  );
};

export default memo(CustomerDetails);
